// Reports one page view per actually-rendered page to POST /page_views.
// Capture happens client-side (on turbo:load) because Turbo's hover-prefetch
// makes server-side request logs ambiguous: un-clicked prefetches inflate the
// counts, while clicked links are served from the prefetch cache and never
// re-hit the server. turbo:load fires exactly once per rendered page —
// initial load, every Turbo visit, and back/forward cache restores.
let previousUrl = null

// Best-effort server response time for the current page. The initial load is
// a "navigation" performance entry; Turbo visits fetch the page as a
// "resource" entry (the prefetch request when the link was hovered, which IS
// the request that produced this render).
function responseTimeMs() {
  try {
    const resources = performance
      .getEntriesByName(location.href)
      .filter((entry) => entry.entryType === "resource")
    // The navigation entry only describes THIS url on the initial full load;
    // after a Turbo visit it still names the first page of the session, and a
    // redirect-landed page (e.g. post-login) has neither entry — return null
    // rather than another page's timing.
    const navigation = performance
      .getEntriesByType("navigation")
      .find((entry) => entry.name === location.href)
    const entry = resources[resources.length - 1] || navigation
    if (!entry || !entry.requestStart || !entry.responseEnd) return null
    const ms = entry.responseEnd - entry.requestStart
    return ms > 0 ? Math.round(ms * 100) / 100 : null
  } catch {
    return null
  }
}

document.addEventListener("turbo:load", () => {
  const referer = previousUrl || document.referrer || null
  previousUrl = location.href

  // Admin pages were never tracked (see PageViewsController); signed-out
  // visitors post too, but the endpoint no-ops without a session cookie.
  if (location.pathname.startsWith("/admin")) return

  const token = document.querySelector('meta[name="csrf-token"]')?.content
  // keepalive lets the request survive an immediate navigation away, like
  // navigator.sendBeacon, but still allows the CSRF header.
  fetch("/page_views", {
    method: "POST",
    keepalive: true,
    headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
    body: JSON.stringify({
      path: location.pathname + location.search,
      referer: referer,
      response_time_ms: responseTimeMs()
    })
  }).catch(() => {})
})
